import styled from 'styled-components';

export const Cell = styled.div<{ columnId: string; $rowIndex: number }>`
  grid-column: col-${({ columnId }) => columnId} / span 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  ${({ theme }) => theme.styles.body.body2};
  padding: 12px ${({ theme }) => theme.spacing.values.plusHalf};
  background-color: ${({ theme, $rowIndex }) =>
    $rowIndex % 2 === 1 &&
    $rowIndex !== undefined &&
    theme.colors.backgroundColors.backgroundSecondary};
`;
